<div [ngClass]="{'disabled': disabled}">

  <section  class="is-flex items-align-center is-fullwidth" ga-event="GraphDate">
    <app-icon  name="chevron-left" class="chevron text-24 text-grey-50 bg-grey-10 bg-grey-hover-30 is-cursor-pointer"
      (click)="selectPreviousTimeRange($event)" ga-event="GraphPrevious">
    </app-icon>
      <ng-container [ngSwitch]="scale">

        <ng-container *ngSwitchCase="EnumScales.DAY">
          <app-day-picker [value]="selectedTimeRange" [minDate]="minDate" (valueChange)="selectTimeRange($event)" class="is-fullwidth">
            <ng-container *ngTemplateOutlet="pickerContent"></ng-container>
          </app-day-picker>
        </ng-container>

        <ng-container *ngSwitchCase="EnumScales.WEEK">
          <app-week-picker [value]="selectedTimeRange" (valueChange)="selectTimeRange($event)" [minDate]="minDate" class="is-fullwidth">
            <ng-container *ngTemplateOutlet="pickerContent"></ng-container>
          </app-week-picker>
        </ng-container>

        <ng-container *ngSwitchCase="EnumScales.MONTH_DAILY">
          <app-month-picker [value]="selectedTimeRange" (valueChange)="selectTimeRange($event)" [minDate]="minDate" [maxDate]="maxDate" class="is-fullwidth">
            <ng-container *ngTemplateOutlet="pickerContent"></ng-container>
          </app-month-picker>
        </ng-container>

        <ng-container *ngSwitchCase="EnumScales.YEAR">
          <app-year-picker [value]="selectedTimeRange" (valueChange)="selectTimeRange($event)" [minDate]="minDate" [maxDate]="maxDate" class="is-fullwidth">
            <ng-container *ngTemplateOutlet="pickerContent"></ng-container>
          </app-year-picker>
        </ng-container>

      </ng-container>

  <ng-template #pickerContent>
   
      <button class="is-flex items-align-center text-section is-cursor-pointer ">
        <app-text [text]="formattedTimeRange" class="is-family-semiBold text-16 text-grey-70"></app-text>
      </button>
  </ng-template>
  <app-icon   name="chevron-right" class="chevron text-24 text-grey-50 bg-grey-10 bg-grey-hover-30 is-cursor-pointer "
    (click)="selectNextTimeRange($event)" ga-event="GraphNext">
  </app-icon>
  </section>
</div>
